<div class="askBox">
  <div class="askWrap">
    <!-- <div class="d-flex">
      <p-selectButton
        [options]="paymentOptions"
        [(ngModel)]="value"
        [multiple]="false"
        optionLabel="name"
        optionValue="value"
      />
    </div>-->
    <div class="textBox">
      <!-- <div class="textBoxTop">
        <label for="">Current personality:</label>
        <p-dropdown
          [options]="boards"
          [(ngModel)]="selectedBoard"
          optionLabel="name"
          placeholder="Project  Manager"
        ></p-dropdown>
      </div>-->
      <div class="inputField">
        <!--<textarea
          #messageInput
          maxlength="200"
          (keydown)="onKeyDown($event)"
          [(ngModel)]="userInput"
          placeholder="Type your message here..."
        ></textarea>-->

        <textarea
          [(ngModel)]="userInput"
          maxlength="200"
          pInputTextarea
          [autoResize]="true"
          (keydown)="onKeyDown($event)"
          placeholder="Ask me anything..."
        ></textarea>
        <p-button
          [disabled]="!userInput"
          (click)="submitUserInput()"
          class="sendBtn"
          icon="pi pi-send"
          label="Send"
        />
      </div>
      <div class="textBoxBottom">
        <!--  <p-button [text]="true">
          <img src="/assets/images/ai/attach.svg" alt="" />
          <span>Attach</span>
        </p-button>-->
        <!-- <p-button [text]="true">
          <img src="/assets/images/ai/microphone.svg" alt="" />
          <span>Voice Message</span>
        </p-button>-->
        <p-button
          icon="pi pi-images"
          styleClass="bg-transparent border-0 w-auto px-2"
          label="Upload image"
        ></p-button>
        <!-- <p-button (click)="browsePrompt()" [text]="true">
          <img src="/assets/images/ai/search.svg" class="mr-2" alt="" />
          <span>Browse Prompts</span>
        </p-button>-->
        <p-button [text]="true" styleClass="creditUsed">
          <img src="/assets/images/ai/coin.png" class="mr-2" alt="" />
          <span>Credit Used 0</span>
        </p-button>
      </div>
    </div>
    <p class="note">
      *All the results are generate by AI, If you are getting any issues <a href="">report here</a>
    </p>
  </div>
</div>
